module.exports = __webpack_public_path__ + "img/in-use-gina-papalia@1x.bdb3cf47.jpg";